import { CAT_RESEARCHES } from 'App/utils/Collections';
import { FT_AUTOCOMPLETE, FT_CHECKBOX, FT_DATE, FT_LIST } from '../FilterTypes';
import { searchSPDomains, searchSPAuthors, loadResearchTypes } from './loaders';
import { ROLE_STAFF } from '@/app/constants/Roles';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
  files: {
    name: 'Files',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_RESEARCHES,
  filters: [
    {
      id: 'domain.id',
      label: 'Domain',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      placeholder: 'Choose domains',
      fieldConf: {
        multiple: true,
        deletebleChips: true,
        chips: true,
        searcher: searchSPDomains,
      },
    },
    {
      id: 'authors.id',
      label: 'Authors',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      placeholder: 'Choose authors',
      fieldConf: {
        multiple: true,
        deletebleChips: true,
        chips: true,
        searcher: searchSPAuthors,
      },
    },
    {
      id: 'types.id',
      label: 'Type',
      type: FT_LIST,
      group: groups.general,
      getListItems: () => loadResearchTypes(),
    },
    {
      id: 'status',
      label: 'Status',
      group: groups.general,
      type: FT_LIST,
      roles: [ROLE_STAFF],
      getListItems: () => {
        return [
          {
            name: 'Pending',
            id: 'pending',
          },
          {
            name: 'Approved',
            id: 'approved',
          },
          {
            name: 'Rejected',
            id: 'rejected',
          },
        ];
      },
    },
    {
      id: 'publishedOn',
      label: 'Published On',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'createdAt',
      label: 'Created At',
      group: groups.date,
      type: FT_DATE,
      roles: [ROLE_STAFF],
    },
    {
      id: 'updatedAt',
      label: 'Updated At',
      group: groups.date,
      type: FT_DATE,
      roles: [ROLE_STAFF],
    },
    {
      id: 'exists[files]',
      label: 'Show Items With Files',
      group: groups.files,
      fieldConf: {
        label: 'Show items with files',
      },
      type: FT_CHECKBOX,
      defaultValue: () => true,
    },
  ],
  searchBarProp: 'complex_name',
};
